export class AssetsServiceClass {
    private readonly _root: string;

    constructor(root: string) {
        this._root = root || "";
    }

    public assetsRoot(): string {
        return this._root || "";
    }

    public getFavIconPath(relativePath: string) {
        if (relativePath.startsWith("/image")) {
            return "https://site-images.similarcdn.com" + relativePath;
        }
        return relativePath;
    }

    public assetUrl(path: string): string {
        if (path && path.startsWith("http")) {
            return path;
        }
        if (this.isImagePath(path)) {
            path = path.replace(/^\/Images\//, "/images/");
        }
        const delimiter = path && path.startsWith("/") ? "" : "/";
        return [this.assetsRoot(), path].join(delimiter);
    }

    public isImagePath(path: string): boolean {
        return /^\/?[iI]mages\/.*/.test(path);
    }

    public normalizeImagePath(path: string): string {
        if (this.isImagePath(path)) {
            return this.assetUrl(path);
        } else {
            return path;
        }
    }
}

export const AssetsService = new AssetsServiceClass(window["assetsRoot"]);
